export default __webpack_public_path__ + "static/media/YGG.d357ba07.png";